<div class="container page-container page-layout" *ngIf="election" >
    <div class="responsive-menu-bar" [class.d-none]="links.length === 0">
      <button class="responsive-search-button" valgButton color="tertiary-icon-right" (click)="sideNav.show(true)" [attr.aria-expanded]="sideNav.showMenu" [attr.aria-controls]="sideNav.id">
        {{ 'navigation.search' | translate }}
        <mat-icon [svgIcon]="SvgIcon.Search"></mat-icon>
      </button>
      <button valgButton color="tertiary-icon-right" #sideNavButton (click)="sideNav.show()" [attr.aria-expanded]="sideNav.showMenu" [attr.aria-controls]="sideNav.id">
        {{ sidenavTitle | translate }}
        <mat-icon [svgIcon]="SvgIcon.ArrowRightDefault"></mat-icon>
      </button>
    </div>
    <div class="row">
        <valg-responsive-menu
          [button]="sideNavButton"
          [sidenavTitle]="sidenavTitle"
          [sidenavParentTitle]="sidenavParentTitle"
          [links]="links"
          [filterLinks]="filterLinks"
          class="col-12 col-lg-3 d-flex"
          #sideNav>
          <div menuTitle>
            <h2 class="h3">
              {{ election.electionType | enumTranslation: "ElectionType"}}
            </h2>
            <span class="subheading small">{{ election.electionDate | date: 'longDate' }}</span>
          </div>

          <a menuBackLink class="back-arrow text text--small mb-5" *ngIf="backLink" [href]="backLink.url">
            <mat-icon class=" mr-1" [svgIcon]="SvgIcon.ArrowLeftDefault"></mat-icon>
            {{ backLink.label | translate }}</a>
        </valg-responsive-menu>
        <div class="col-12 col-lg-9" [class.col-md-12]="links.length > 0">
            <ng-content></ng-content>
        </div>
    </div>
  </div>
